import util from "@/mixins/util";
import EventBus from "@/mixins/event-bus";
import alertMixins from "@/mixins/alertMixins";
export default {
    date() {
        return {}
    },
    computed: {},
    mixins: [alertMixins],
    methods: {
        updateStatus(params){
            if(util.isEmpty(params))return
            EventBus.$emit('changeLoading',true)
            try{
                this.$api.$order.updateOrderStatus(params).then(res => res.Data.Result).then(res => {
                    let type = this.returnUpdateType(res.Info.Type)
                    if (type !== true) {
                        EventBus.$emit('changeLoading',false)
                        this.errorAlert(type)
                    }else{
                        this.afterFunc()
                    }
                })
            }catch (e) {
                console.log(e)
            }
        },
        afterFunc(list=false){
            EventBus.$emit('changeLoading',false)
            this.createAlert({
                content: '상태 변경이 완료되었습니다.',
                hide: () => {
                    if(list){
                        EventBus.$emit('resetOrderData')
                        return false
                    }
                    this.$router.back();
                }
            })
        },
        returnUpdateType(type){
            if (type === 1) {
                return true;
            } else {
                return '상태 변경 실패하였습니다.';
            }
        },
        multipleUpdateStatus(status){
            if(util.isEmpty(this.selectRow)){
                this.errorAlert('주문건을 선택해주세요.')
                return false
            }
            let noInvoice = 0
            util.Array.each(this.selectRow, (data, index, arr) => {
                if(util.isEmpty(data.ce_invoice) || util.isEmpty(data.ed_name)){
                    noInvoice += 1
                }
            })

            let params =[]
            util.Array.each(this.selectRow, (data, index, arr) => {
                params.push({c_idx:data.c_idx.toString(),c_status:status})
            })

            this.runMultiUpdateStatus(params)
        },
        multiplePreparingUpdate(status){
            if(util.isEmpty(this.selectRow)){
                this.errorAlert('주문건을 선택해주세요.')
                return false
            }
            let noInvoice = 0
            util.Array.each(this.selectRow, (data, index, arr) => {
                if(!this.checkDeliveryInfo(data)){
                    noInvoice += 1
                }
            })

            if(noInvoice !== 0){
                this.errorAlert('배송정보 없는 항목이 있습니다.')
                return false
            }else{
                let params =[]
                util.Array.each(this.selectRow, (data, index, arr) => {
                    params.push({c_idx:data.c_idx.toString(),c_status:status})
                })

                this.runMultiUpdateStatus(params)
            }
        },
        runMultiUpdateStatus(params){
            let allCnt = params.length // 전체 갯수
            let failCnt = 0 // 실패갯수
            let requestCnt = 0;
            EventBus.$emit('changeLoading',true)
            util.Array.each(params, (data, index, arr) => {
                try{
                    this.$api.$order.updateOrderStatus(data).then(res => res.Data.Result).then(res => {
                        requestCnt++
                        let type = this.returnUpdateType(res.Info.Type)
                        if (type !== true) {
                         //   EventBus.$emit('changeLoading',false)
                           // this.errorAlert(type)
                            failCnt++

                        }
                        if(requestCnt == params.length) {
                            this.listAfterFunc(allCnt,failCnt)
                        }
                    })
                }catch (e) {
                    console.log(e)
                }
            })

        },
        listAfterFunc(all=0,fail=0){
            EventBus.$emit('changeLoading',false)
            if(fail === 0){ // 전체 성공인 경우
               this.afterFunc(true)
                return false
            }else if(all == fail) { // 전체 실패인 경우
                this.errorAlert('상태 변경 실패하였습니다.')
            }else { // 일부 실패의 경우
                this.errorAlert('일부 항목의 상태 변경에 실패했습니다.')
            }
            // 전체 실패및 일부실패경우 리스트 재호출
            EventBus.$emit('resetOrderData')
        },
        checkDeliveryInfo(data){ // 배송사 이름, 송장번호
            return !util.isEmpty(data.addressInfo) && !util.isEmpty(data.addressInfo[0].ed_name) && !util.isEmpty(data.addressInfo[0].ce_invoice)
        },
        multipleSetShipping(){ // 묶음 배송시
            if(util.isEmpty(this.selectRow)){
                this.errorAlert('주문건을 선택해주세요.')
                return false
            }
            if(this.selectRow.length <2){
                this.errorAlert('묶음 배송할 2개 이상의 <br>주문건을 선택해주세요.')
                return false
            }
            let selectArr =[]
            util.Array.each(this.selectRow, (data, index, arr) => {
                selectArr.push(data.c_idx)
            })
            this.$modal.show('order-delivery-modal',{'selectArr':selectArr})
        },
        openOnlyOneUpdateExpress(row){ // 하나만 수정시
            let makeData = {}
            if(this.checkDeliveryInfo(row)){ // 수정일시
                let data = row.addressInfo[0];
                makeData ={'selectArr':[row.c_idx],'data':data}
            }else { // 등록일시 배열만 전달
                makeData ={'selectArr':[row.c_idx]}
            }
            this.$modal.show('order-delivery-modal',makeData)
        },
        returnOption(data){
            return util.isEmpty(data)? '-' : data
        },
        returnOrderStatus(status){ // list에서 사용
            switch (status) {
                case 10:
                    return '입금대기';
                case 20:
                    return '결제완료';
                case 21:
                    return '상품준비중';
                case 30:
                    return '배송준비중';
                case 40:
                    return '배송중';
                case 50:
                    return '배송완료';
                case 60:
                    return '구매확정';
                case 100:
                    return '취소요청';
                case 102:
                    return '취소승인';
                case 105:
                    return '취소완료';
                case 109:
                    return '취소거절';
                case 110:
                    return '교환요청';
                case 112:
                    return '교환승인';
                case 113:
                    return '교환중';
                case 115:
                    return '교환완료';
                case 119:
                    return '교환요청거절';
                case 120:
                    return '환불요청';
                case 122:
                    return '환불중';
                case 123:
                    return '환불중';
                case 125:
                    return '환불완료';
                case 129:
                    return '환불거절';
                default:
                    return '-';
            }
        },

        moveOrderDetail(row) {
            let route = this.returnOrderStatusRouterName(row.c_status);
            let key = this.returnDetailOrderKey(row);
            let path = `/order/${route}/${key}`
            this.$router.push(path)
        },
        returnDetailOrderKey(row) {
            let route = this.returnOrderStatusRouterName(row.c_status);
            let key = row.c_idx;
            if(route == 'after/cancel' && !util.isEmpty(row.cancelInfo)) {
                key = row.cancelInfo[0].cc_idx;
            }
            if(route == 'after/refund' && !util.isEmpty(row.refundInfo)) {
                key = row.refundInfo[0].cr_idx;
            }
            if(route == 'after/exchange' && !util.isEmpty(row.tradeInfo)) {
                key = row.tradeInfo[0].ct_idx;
            }
            return key;
        },
        returnOrderStatusRouterName(status){ // list 상세 라우터 이동시 사용
            switch (status) {
                case 10:
                    return 'before';
                case 20:
                    return 'complete';
                case 21:
                    return 'itemready';
                case 30:
                    return 'preparing';
                case 40:
                    return 'shipping';
                case 50:
                    return 'shipping/done';
                case 60:
                    return 'shipping/done';
                case 100:
                    return 'after/cancel';
                case 102:
                    return 'after/cancel';
                case 105:
                    return 'after/cancel';
                case 109:
                    return 'after/cancel';
                case 110:
                    return 'after/exchange';
                case 112:
                    return 'after/exchange';
                case 113:
                    return 'after/exchange';
                case 115:
                    return 'after/exchange';
                case 119:
                    return 'after/exchange';
                case 120:
                    return 'after/refund';
                case 122:
                    return 'after/refund';
                case 123:
                    return 'after/refund';
                case 125:
                    return 'after/refund';
                case 129:
                    return 'after/refund';
                default:
                    return '-';
            }
        },
        returnCancelStatus(status) {
            //0:취소요청,1:취소승인,2:취소철회
            switch (status) {
                case 0:
                    return '취소요청';
                case 1:
                    return '취소승인';
                case 2:
                    return '취소요청 철회';
                default:
                    return '-'
            }
        },
        returnExchangeStatus(status) {
            //0:교환요청,1:교환승인(교환중),2:교환거절,3:교환완료,4:교환철회
            switch (status) {
                case 0:
                    return '교환요청';
                case 1:
                    return '교환중';
                case 2:
                    return '교환요청 거절';
                case 3:
                    return '교환완료';
                case 4:
                    return '교환요청 철회';
                default:
                    return '-'
            }
        },
        returnRefundStatus(status) {
            //0:환불요청,1:환불승인(환불중),2:환불거절,3:환불완료,4:환불철회
            switch (status) {
                case 0:
                    return '환불요청';
                case 1:
                    return '환불중';
                case 2:
                    return '환불요청 거절';
                case 3:
                    return '환불완료';
                case 4:
                    return '환불요청 철회';
                default:
                    return '-'
            }
        },
    },
}
